export type RecordState = "active" | "archived";

export interface BillingAddressInput {
  line1: string | null;
  line2: string | null;
  locality: string | null;
  region: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface ClientContactRecord {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  isPrimary: boolean;
  state: RecordState;
  version: number;
  billingAddress: BillingAddressInput;
}

export interface ClientRecord {
  searchMatch?: import("../../shared/navigation-search").SearchMatch;
  id: string;
  displayName: string;
  invoicePrefix?: string | null;
  state: RecordState;
  version: number;
  primaryContact: ClientContactRecord | null;
  billingAddress: BillingAddressInput;
}

export interface ClientInput {
  displayName: string;
  invoicePrefix?: string | null;
  billingAddress: BillingAddressInput;
}

export interface ClientCreateInput extends ClientInput {
  primaryContact: Omit<ContactInput, "isPrimary"> | null;
  additionalContacts: Array<Omit<ContactInput, "isPrimary">>;
}

export interface ContactInput {
  name: string;
  email: string | null;
  phone: string | null;
  isPrimary: boolean;
  billingAddress?: BillingAddressInput;
}

export class ClientInputError extends Error {}
export class ClientNotFoundError extends Error {}
export class ClientConflictError extends Error {}
